import { httpClient } from "./httpClient";

export function createContract(payload) {
  return httpClient.post("/contract", payload);
}

export function getContract(contractId) {
  return httpClient.get(`/contract/${contractId}`);
}

export function completeBuyerContract(contractId, payload) {
  return httpClient.patch(`/contract/complete/buyyer/${contractId}`, payload);
}

export function completeSellerContract(contractId, payload) {
  return httpClient.patch(`/contract/complete/seller/${contractId}`, payload);
}

export function deleteContract(contractId) {
  return httpClient.delete(`/contract/${contractId}`);
}
